const fixedMdUp = document.querySelector('[data-fixed-on-md-up]');
const fixedMdUpContainer = document.querySelector('[data-fixed-on-md-up-container]');
const tariffStickyHeaderTariffs = document.querySelector('[data-tariff-container]');
const tariffStickyHeaderContainer = document.querySelector('[data-fixed-option-col-sm]');

function setRequiredHrefPoints(container) {
    if (!container) {
        return;
    }
    const minWindowWidthAnchor = 768;
    const windowWidth = window.innerWidth;
    const links = container.querySelectorAll('a');
    const smUpId = '-sm-up';

    links.forEach(function(link) {
        let href = link.getAttribute('href');

        if (windowWidth < minWindowWidthAnchor) {
            link.setAttribute('href', href.replace(smUpId, ''));
            return;
        }

        if (href.indexOf(smUpId) === -1) {
            link.setAttribute('href', href + smUpId);
        }
    });
}

function stickySidebarMdUp() {
    if (fixedMdUp && fixedMdUpContainer) {
        const minWindowWidthFixed = 992;
        let windowWidth = window.innerWidth;
        const container = fixedMdUpContainer;
        let containerWidth = container.offsetWidth;
        const containerTop = container.offsetTop;
        const footer = document.querySelector('footer');
        let footerScrollPos = (footer.offsetTop - fixedMdUp.offsetHeight) - 40;

        if (windowWidth >= minWindowWidthFixed) {
            fixedMdUp.style.width = containerWidth + 'px';
        }

        window.addEventListener('scroll', function() {
            const yPos = window.pageYOffset;
            fixedMdUp.classList.toggle('fixed', yPos > containerTop);
            fixedMdUp.classList.toggle('footer-scroll-position', yPos > footerScrollPos);
        });

        window.addEventListener('resize', function() {
            windowWidth = window.innerWidth;
            containerWidth = container.offsetWidth;
            fixedMdUp.style.width = windowWidth >= minWindowWidthFixed ? containerWidth + 'px' : 'auto';
            setRequiredHrefPoints(container);
        });
    }
}

function tariffStickyHeaderMdDown() {
    if (tariffStickyHeaderTariffs && tariffStickyHeaderContainer) {
        window.addEventListener('scroll', function() {
            const yPos = window.pageYOffset;
            const headerMenuOffset = 35;
            const tariffStickyHeaderOffset = 0;
            const containerTop = tariffStickyHeaderTariffs.offsetTop - headerMenuOffset;
            const containerTopWithOffset = containerTop - tariffStickyHeaderOffset;
            const containerBottom = containerTop + tariffStickyHeaderTariffs.offsetHeight;
            tariffStickyHeaderTariffs.classList.toggle('show-sticky-tariff-options', (yPos > containerTopWithOffset) && (yPos < containerBottom));
        });
    }
}

document.addEventListener('DOMContentLoaded', function() {
    stickySidebarMdUp();
    setRequiredHrefPoints(fixedMdUpContainer);
    tariffStickyHeaderMdDown();
});
